package com.ervasstudio.tracoemovimento.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window

@Composable
fun rememberIsMobile(breakpointPx: Int = 768): Boolean {
    var isMobile by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        // Estado inicial (após montagem no browser)
        isMobile = window.innerWidth <= breakpointPx
    }

    DisposableEffect(Unit) {
        val listener: (org.w3c.dom.events.Event) -> Unit = {
            isMobile = window.innerWidth <= breakpointPx
        }
        window.addEventListener("resize", listener)
        onDispose { window.removeEventListener("resize", listener) }
    }

    return isMobile
}